/** Filter keys used by the event table multi-select chips. */
export const FUEL_EVENT_FILTER = {
  SPIKE_REJECTED: 'SPIKE_REJECTED',
  REFILL: 'REFILL',
  DRAIN: 'DRAIN',
  ALERT: 'ALERT',
  STITCH: 'STITCH',
};

export const eventLabelToFilterKey = (eventLabel) => {
  const normalized = String(eventLabel || '').trim().toUpperCase();
  if (normalized.includes('SPIKE')) return FUEL_EVENT_FILTER.SPIKE_REJECTED;
  if (normalized.includes('REFILL')) return FUEL_EVENT_FILTER.REFILL;
  if (normalized.includes('DRAIN') || normalized.includes('THEFT')) return FUEL_EVENT_FILTER.DRAIN;
  if (normalized.includes('ALERT')) return FUEL_EVENT_FILTER.ALERT;
  if (normalized.includes('STITCH')) return FUEL_EVENT_FILTER.STITCH;
  return normalized.replace(/\s+/g, '_');
};
